import { IconButton, Sheet, XIcon } from "@au-schein-de/au-ui-library";

export const PHARMACY_PICKER_FILTER_SHEET_Z_CLASS = "z-[130]";

export const PHARMACY_PICKER_FILTER_SHEET_CONTENT_CLASS =
	"rounded-t-3xl bg-gray-100 p-6 [&>button.absolute]:hidden z-[130]";

export function PharmacyPickerFilterSheetHeader({
	title,
	onClose,
	closeLabel,
	closeTestId,
}: {
	title: string;
	onClose: () => void;
	closeLabel: string;
	closeTestId: string;
}) {
	return (
		<Sheet.Header className="mb-6 flex flex-row items-center justify-between space-y-0 text-left">
			<Sheet.Title className="text-h5 text-gray-700">{title}</Sheet.Title>
			<IconButton
				onClick={onClose}
				icon={<XIcon.Raw />}
				shape="circle"
				className="bg-white"
				aria-label={closeLabel}
				data-testid={closeTestId}
			/>
		</Sheet.Header>
	);
}
